import React, {Component} from 'react'
import PropTypes from 'prop-types'
import ReactGA from 'react-ga'
import {Route} from 'react-router-dom'
import config from "../cfg/config";
const {environment} = config;

const isAnalyticsEnabled = () => {
    return !config.development
}

class GoogleAnalytics extends Component {
    componentDidMount() {
        this.logPageChange(
            this.props.location.pathname,
            this.props.location.search
        )
    }

    componentDidUpdate({location: prevLocation}) {
        const {location: {pathname, search}} = this.props
        const isDifferentPathname = pathname !== prevLocation.pathname
        const isDifferentSearch = search !== prevLocation.search

        if (isDifferentPathname || isDifferentSearch) {
            this.logPageChange(pathname, search)
        }
    }

    logPageChange(pathname, search = '') {
        const page = pathname + search
        const {location} = window
        if (isAnalyticsEnabled()) {
            ReactGA.set({
                page,
                location: `${location.origin}${page}`,
                ...this.props.options
            })
            ReactGA.pageview(page)
        }
    }

    render() {
        return null
    }
}

GoogleAnalytics.propTypes = {
    location: PropTypes.shape({
        pathname: PropTypes.string,
        search: PropTypes.string
    }).isRequired,
    options: PropTypes.object
}

const RouteTracker = () =>
    <Route component={GoogleAnalytics}/>


const init = (options = {}) => {
    const { analytics } = config

    if (analytics) {
        const env = window._env_ || {
            REACT_APP_GA_TRACKING_ID: analytics.trackingId,
            REACT_APP_GA_DEBUG: analytics.debug || false,
        }
        if (isAnalyticsEnabled()) {
            ReactGA.initialize(env.REACT_APP_GA_TRACKING_ID, {
                debug: env.REACT_APP_GA_DEBUG, ...options,
            })
        } else {
            console.log('Google Analytics is disabled')
        }
    }

    if (isAnalyticsEnabled()) {
        (function (apiKey) {
            (function (p, e, n, d, o) {
                var v,
                  w,
                  x,
                  y,
                  z;
                o = p[d] = p[d] || {};
                o._q = o._q || [];
                v = [
                    'initialize',
                    'identify',
                    'updateOptions',
                    'pageLoad',
                    'track'];
                for (w = 0, x = v.length; w < x; ++w) (function (m) {
                    o[m] = o[m] || function () {
                        o._q[m === v[0] ? 'unshift' : 'push'](
                          [m].concat([].slice.call(arguments, 0)));
                    };
                })(v[w]);
                y = e.createElement(n);
                y.async = !0;
                y.src = 'https://cdn.pendo.io/agent/static/' + apiKey +
                  '/pendo.js';
                z = e.getElementsByTagName(n)[0];
                z.parentNode.insertBefore(y, z);
            })(window, document, 'script', 'pendo');
        })('f4ca0735-c4f2-4eef-77f5-771985c02f3e');
    }

    return isAnalyticsEnabled() && analytics || false;
}

const setField = (params) => {
    if (isAnalyticsEnabled()) {
        const ga = ReactGA.ga();
        for (let key of Object.keys(params)) {
            ga && ga('set', key, params[key]);
        }
    }
}

const setEvent = (eventParams) =>{
    if(isAnalyticsEnabled()){
        ReactGA.event(eventParams);

        if(window.pendo) {
            const {
                category, action,
                ...others
            } = eventParams;

            delete others.dimension1;
            delete others.dimension2;
            delete others.dimension3;
            delete others.dimension4

            const eventName = `${category} - ${action}`;

            pendo.track(eventName, {
                ...others
            });
        }
    }
}

const initPendo = (user, org) => {
    if(!isAnalyticsEnabled()){
        return;
    }

    const auth = user.authorizations.find(a => a.org == org.id)
    const role = auth && auth.roles && JSON.stringify(auth.roles);

    const pendoParams = {
        visitor: {
            id: user.id,
            email: user.attributes.email ,
            full_name: `${user.attributes.given_name} ${user.attributes.family_name}`,
            role
        },


        account: {
            id: org.id,  // Required if using Pendo Feedback, default uses the value 'ACCOUNT-UNIQUE-ID'
            name: org.domain,         // Optional
            // is_paying:    // Recommended if using Pendo Feedback
            // monthly_value:// Recommended if using Pendo Feedback
            planLevel: org.license && org.license.name,  // Optional
            creationDate: org.createdOn, // Optional
            licenseAddedOn: org.license && org.license.addedOn,

            // You can add any additional account level key-values here,
            // as long as it's not one of the above reserved names.
            environment
        },
    }

    if(window.pendo) {
        pendo.initialize(pendoParams);
    }
}

export {ReactGA};

export default {
    GoogleAnalytics,
    RouteTracker,
    init,
    setField,
    setEvent,
    initPendo
}
